function isEmpty() {
	return !this && !this.trim()
}
String.prototype.isEmpty = isEmpty
